import { Component } from "@angular/core";

import { Tab, NavParams, MenuController, NavController } from "ionic-angular";

import { InventoryAllPage } from "../inventoryall/inventoryall";

import { TabInventoryPending } from "../inventorypendingtabs/tabs-inventorypending";

@Component({
  selector: "tabs-inventory",
  templateUrl: "tabs-inventory.html"
})
export class TabInventory {
  // set the root pages for each tab
  all: any = InventoryAllPage;
  pending: any = TabInventoryPending;

  mySelectedIndex: any = 0;

  constructor(
    navParams: NavParams,
    public menu: MenuController,
    public navCtrl: NavController
  ) {}

  ionViewDidLoad() {
    this.menu.enable(true);
  }

  tabChanged(tab: Tab) {}
}



// WEBPACK FOOTER //
// ./src/pages/inventory/tabs/tab-inventory.ts